<div class="row">
  
  <div class="col">
    <h3>Envio de arquivo de operações leiloadas</h3>
  </div>
  <div class="col-auto d-flex">
    <div>
      <button
        class="btn btn-secondary"
        type="button"
        placement="bottom"
        (click)="baixarExemploLeiloes()"
        ngbTooltip="Exporta um arquivo JSON de exemplo para o envio de operações leiloadas."
      >
        <i class="fa fa-file"></i> Exemplo de arquivo operações leiloadas
      </button>
    </div>

    <div>
      <button class="btn btn-secondary" (click)="limpar()" type="button">
        Limpar
      </button>
    </div>

    <div>
      <button class="btn btn-primary" (click)="voltar()" type="button">
        Voltar
      </button>
    </div>

    <div>
      <button class="btn btn-primary" type="button"
        *ngIf="!enviado" [disabled]="!loteLeilaoForm.valid || loteLeilaoForm.pristine" type="button" (click)="onSubmit()">Enviar</button>
    </div>
  </div>
</div>
<div class="col">
  <p>Envie um arquivo com suas operações leiloadas.</p>
</div>
<div class="container">
  <form [formGroup]="loteLeilaoForm" (validSubmit)="onSubmit()">
    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="arquivo">Arquivo:</label>
        <div id="customFile">
          <input
            type="file"
            accept=".json"
            class="form-control"
            id="arquivo"
            (change)="onFileChange($event)"
            #fileInput
            formControlName="arquivo"
          />
        </div>
        <label class="arquivo-selecionado form-label" *ngIf="arquivo?.tipoConteudo"
          >Arquivo de {{ labelTipoConteudo }} selecionado para importação</label
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <input type="radio" value="validar" formControlName="opcaoEnvio" />
        Apenas validar
      </div>
      <div class="col-md-2">
        <input type="radio" value="contratar" formControlName="opcaoEnvio" />
        Efetivar envio
      </div>
    </div>
    <br />
  </form>
</div>

<div class="container">
  <div class="alert alert-warning container-alert">
    Permitido um <span class="bold">único arquivo válido por dia.</span> Caso
    ocorra envio de um novo arquivo no mesmo dia, o arquivo válido anterior,
    caso exista, será SUBSTITUÍDO se o novo arquivo for válido. Sendo o novo
    arquivo não válido, então permanesce o último envio válido realizado.
  </div>
</div>

<div>
  <div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
      <table class="table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-center">
              Operação
            </th>
            <th class="text-center">
              Erro(s) encontrado(s)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ocorrencia of ocorrencias">
              <td width="20%">
                  {{ ocorrencia.idObjetoValidado }}
              </td>
              <td width="80%">
                  {{ ocorrencia.mensagem }}
              </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="obs-erro">Nenhuma leilão foi protocolada. Em caso de parâmetro inválido com mensagem "não deve ser nulo", verificar se o nome do parâmetro está correto no JSON enviado.</p>
  </div>
</div>

<bn-loading-overlay></bn-loading-overlay>